<script lang="ts">
    import { websiteName } from "../../configs/config"
    let {
        pageTitle = "",
        metaDescription = "",
        metaKeywords = "",
        noIndex = false,
        active = true,
        canonical = "",
    } = $props()
</script>

<svelte:head>
    <title>{pageTitle}</title>
    {#if canonical}
        <link rel="canonical" href={canonical} />
    {/if}
    <meta name="description" content={metaDescription} />
    {#if metaKeywords}
        <meta name="keywords" content={metaKeywords} />
    {/if}
    <meta property="og:site_name" content={websiteName} />
    {#if noIndex || active === false}
        <meta name="robots" content="noindex, nofollow" />
    {:else}
        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
    {/if}
</svelte:head>
